export default {
  namespaced: true,
  state: {
    referralLinks: [],
    count: 0,
    count: 0,
  },
  getters: {
    referralLinks: (state) => state.referralLinks,
    count: (state) => state.count,
  },
  mutations: {
    referralLinks: (state, payload) => (state.referralLinks = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("referral-links", {
          params: queryParams,
        })
        .then((res) => {
          commit("referralLinks", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    getReferralLinks({ commit }, queryParams) {
      return this.$apiService
        .get("get-referral-links", {
          params: queryParams,
        })
        .then((res) => {
          commit("referralLinks", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("referral-links", payload);
    },
    show({}, id) {
      return this.$apiService.get(`referral-links/${id}`);
    },
    update({}, { id, data }) {
      return this.$apiService.put(`referral-links/${id}`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`referral-links/${id}`);
    },
  },
};
